// 资讯管理
export default [
  {
    path: "/dynamic",
    meta: { title: "资讯管理" },
    component: () => import("../views/dynamic/index.vue"),
    children: [
      {
        path: "/dynamic/list",
        meta: { title: "资讯列表", isMenu: true },
        component: () => import("../views/dynamic/list.vue"),
      },
      {
        path: "/dynamic/list/detail/add",
        meta: { title: "动态资讯" },
        component: () => import("../views/dynamic/detail/add.vue"),
      },
    ],
  },
]
